import { VideoCard } from './index';
import { YouTubeVideoWordpress, youtubeDurationToSeconds } from '@benzinga/videos-manager';

export interface YouTubeVideoCardProps {
  video: YouTubeVideoWordpress;
}

export const YouTubeVideoCard: React.FC<YouTubeVideoCardProps> = ({ video }) => {
  const duration = youtubeDurationToSeconds(video.contentDetails.duration ?? '');
  return (
    <VideoCard
      duration={duration}
      id={video.video_id}
      // playlistId={}
      title={video.title}
      variant="default"
    />
  );
};
